import React from 'react';
import { UserIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function ArcheryManager() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-258">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-259">
        <div className="mb-12" data-id="element-260">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-261">
            Archery Manager
          </h2>
          <div className="bg-white rounded-xl p-6 md:p-8 shadow-sm border flex flex-col sm:flex-row items-center justify-between gap-6" style={{
          borderColor: '#ede9e0'
        }} data-id="element-262">
            <div className="flex items-center gap-4" data-id="element-263">
              <div className="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: 'rgba(30,61,47,0.08)'
            }} data-id="element-264">
                <UserIcon size={28} style={{
                color: '#1e3d2f'
              }} data-id="element-265" />
              </div>
              <div data-id="element-266">
                <p className="text-xl font-bold uppercase" style={{
                fontFamily: 'Oswald, sans-serif',
                color: '#1e3d2f'
              }} data-id="element-267">
                  Chip Marks
                </p>
                <p className="text-sm" style={{
                color: '#5a5a5a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-268">
                  Archery Manager
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-3 w-full sm:w-auto" data-id="element-269">
              <a href="tel:2487874848" className="flex items-center justify-center sm:justify-start gap-2 px-4 py-2.5 rounded-lg transition-all hover:bg-gray-50 border" style={{
              borderColor: '#ede9e0',
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-270">
                <PhoneIcon size={16} style={{
                color: '#c8a84b'
              }} data-id="element-271" />
                <span className="font-medium" data-id="element-272">248-787-4848</span>
              </a>
              <a href="mailto:ClubArcheryMgr@fentonlakes.com" className="flex items-center justify-center sm:justify-start gap-2 px-4 py-2.5 rounded-lg transition-all hover:bg-gray-50 border" style={{
              borderColor: '#ede9e0',
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-273">
                <MailIcon size={16} style={{
                color: '#c8a84b'
              }} data-id="element-274" />
                <span className="font-medium" data-id="element-275">
                  ClubArcheryMgr@fentonlakes.com
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
}